/* 1776 Atelier — About wing, v2. Motion belongs to arrival only.
   Hero pieces arrive staged on load; scrolled elements rise once as they
   enter and then rest. Nothing tracks the cursor; nothing moves on hover. */
(function () {
  /* ---- staged hero entrance ---- */
  var enters = [].slice.call(document.querySelectorAll('[data-enter]'));
  enters.forEach(function (el, i) {
    el.style.transitionDelay = (120 + i * 130) + 'ms';
  });
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      enters.forEach(function (el) { el.classList.add('is-on'); });
      /* delays served their purpose; clear so nothing lags later */
      setTimeout(function () {
        enters.forEach(function (el) { el.style.transitionDelay = ''; });
      }, 2400);
    });
  });

  /* ---- scroll reveals, staggered per arriving batch ---- */
  var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var batch = [];
  var flush = null;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      batch.push(e.target);
      io.unobserve(e.target);      /* arrival happens once — no re-fidgeting */
    });
    if (batch.length && !flush) {
      flush = requestAnimationFrame(function () {
        /* stagger the batch in document order */
        batch.sort(function (a, b) {
          return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        });
        batch.forEach(function (el, i) {
          el.style.setProperty('--rd', Math.min(i * 110, 660) + 'ms');
          el.classList.add('is-in');
        });
        batch = [];
        flush = null;
      });
    }
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { io.observe(el); });
})();
